import { StatusNFeSaidaEnum } from '../enums/repo-dfe/status-nfe-saida.enum';

/**
 * Traduz o status da NF-e de saída na classe global de badge correspondente.
 * As cores acompanham os cards da listagem, usando somente as classes já existentes no styles.css.
 */
export function classeBadgeStatusNFeSaida(idStatusNFeSaida: number | null | undefined): string {
  switch (idStatusNFeSaida) {
    case StatusNFeSaidaEnum.AguardandoTransmissao: return 'badge-amarelo';
    case StatusNFeSaidaEnum.EmTransmissao: return 'badge-azul';
    case StatusNFeSaidaEnum.Autorizada: return 'badge-verde';
    case StatusNFeSaidaEnum.Rejeitada: return 'badge-vermelho';
    case StatusNFeSaidaEnum.Cancelada: return 'badge-cinza';
    case StatusNFeSaidaEnum.Denegada: return 'badge-vinho';
    default: return 'badge-cinza';
  }
}

export function iconeStatusNFeSaida(idStatusNFeSaida: number | null | undefined): string {
  switch (idStatusNFeSaida) {
    case StatusNFeSaidaEnum.AguardandoTransmissao: return 'pending_actions';
    case StatusNFeSaidaEnum.EmTransmissao: return 'sync';
    case StatusNFeSaidaEnum.Autorizada: return 'check_circle';
    case StatusNFeSaidaEnum.Rejeitada: return 'error';
    case StatusNFeSaidaEnum.Cancelada: return 'cancel';
    case StatusNFeSaidaEnum.Denegada: return 'block';
    default: return 'help';
  }
}
